<template>
  <figure class="collection-image"> 
    <interactive-image v-if="image.type === 'image-360'" :id="image.src" :alt="image.alt"></interactive-image>
    <img v-else :src="image.src" :alt="image.alt">
    <div class="table vcenter-content h7 century-mono" v-if="hasTable">
      <div class="inner vcenter">
        <h4>{{image.table.header}}</h4>
        <div v-html="image.table.text"></div>
      </div>
    </div>
    <figcaption v-html="setCaption(image)"></figcaption>
  </figure>
</template>

<script>
import Config from 'src/config'
import InteractiveImage from 'components/InteractiveImage'
export default {
  name: 'CollectionImage',
  props: {
    image: {
      type: Object,
      default: {
        type: null,
        src: null,
        caption: null,
        alt: '',
        table: null,
        grayscale: false
      }
    }
  },
  components: {
    InteractiveImage
  },
  computed: {
    grayscale () {
      return this.image.grayscale === 'undefined' ? false : this.image.grayscale
    },
    hasTable () {
      return this.image.table && (this.image.table.header || this.image.table.text) && this.image.type !== 'image-360'
    }
  },
  methods: {
    setCaption (image) {
      let caption = image.caption
      if (image.type === 'image-360' && window.innerWidth > Config.bkpt.image360) {
        const after = ' (Rollover to view)'
        caption = caption.indexOf('</p>') ? caption.replace('</p>', after + '</p>') : caption + after
      }
      return caption
    }
  }
}
</script>

<style lang="scss">
@import '../style/variables';

.collection-image{
  position:relative;
  width:100%;
  img {
    width:100%;
  }
  .table{
    @include background(absolute,100%);
    color:$white;
    padding:0 $gutter*2;
    .inner{
      width:100%;
      max-width:33.33em;
      border-style: solid;
      border-width:0.1em;
      text-shadow:0 0 2px $black;
    }
    h4 {
      border-width:0.1em;
      border-bottom-style: solid;
      padding:1.66em $gutter; // 2em;
    }
    p {
      width:50%;
      float:left;
      margin:1.66em 0;
      padding:0 $gutter;
      text-align: left;
      .collection-spread & {
        @media (max-width:1024px) {
          float:none;
          width:100%;
          margin:1.66/2*1em 0;
          &:first-of-type{
            margin-top:1.66em;
          }
          &:last-of-type{
            margin-bottom:1.66em;
          }
        }
      }
    }
  }

  // show table on hover
  // .no-touchevents &{
    .table{
      opacity:0;
      @include transition(opacity .5s);
    } 
    &:hover {
      .table{
        opacity:1;
      }
    } 
  // } 

  // grayscale  
  @include filter(grayscale(100%));
  @include transition(filter .25s, -webkit-filter .25s);
  &:hover {
    @include filter(grayscale(0%));
  }

  // mobile
  @include on_mobile () {
    .table {
      display:none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// CollectionImage.vue?25a2a088